import script from "./TripView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TripView.vue?vue&type=script&setup=true&lang=ts"

import "./TripView.vue?vue&type=style&index=0&id=6a0ea81b&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_d0e91f904bb1d11c0b68168201cc497f/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a0ea81b"]])

export default __exports__